function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "delete_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  className: "delete_svg__a",
  transform: "translate(47 197)",
  d: "M0 0h16v16H0z"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  className: "delete_svg__b"
}, /*#__PURE__*/React.createElement("path", {
  className: "delete_svg__c",
  d: "M3.3 16a.3.3 0 01-.3-.3V15h10v.7a.3.3 0 01-.3.3zm8.7-1V4H4v11H3V4h-.7a.3.3 0 01-.3-.3V2.3a.3.3 0 01.3-.3H5V.3a.3.3 0 01.3-.3h5.4a.3.3 0 01.3.3V2h2.7a.3.3 0 01.3.3v1.4a.3.3 0 01-.3.3H13v11zm-3-1.5v-8h1v8zm-3 0v-8h1v8z"
}));

function SvgDelete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), _ref, _ref2);
}

export default SvgDelete;